import { motion } from "framer-motion";

const EASE = [0.19, 1, 0.22, 1];

// Fade-up scroll reveal
export const Reveal = ({ children, delay = 0, y = 34, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, ease: EASE, delay }}
    {...props}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal (hero). Pass an array of strings.
export const MaskReveal = ({ lines, className = "", delay = 0, itemClassName = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
        <motion.span
          className={`block ${itemClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.15, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Simple fade in
export const FadeIn = ({ children, delay = 0, duration = 1.2, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration, ease: EASE, delay }}
    {...props}
  >
    {children}
  </motion.div>
);
